import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import "./style.css";
const Navigation = () => {
    const history = useHistory();
    const [price, setPrice] = useState({});
    useEffect(() => {
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", "goldapi-ztttvtl4tq6d31-io");
        myHeaders.append("Content-Type", "application/json");

        var requestOptions = {
            // method: "GET",
            headers: myHeaders,
            redirect: "follow",
        };
        fetch("https://www.goldapi.io/api/XAU/USD", requestOptions)
            .then((response) => response.json())
            .then((result) => setPrice(result));
    }, []);
    // console.log(price.price, price.chp);
    const slideUp = (target, time) => {
        const duration = time ? time : 500;
        target.style.transitionProperty = "height, margin, padding";
        target.style.transitionDuration = duration + "ms";
        target.style.boxSizing = "border-box";
        target.style.height = target.offsetHeight + "px";
        // target.offsetHeight;
        target.style.overflow = "hidden";
        target.style.height = 0;
        window.setTimeout(() => {
            target.style.display = "none";
            target.style.removeProperty("height");
            target.style.removeProperty("overflow");
            target.style.removeProperty("transition-duration");
            target.style.removeProperty("transition-property");
        }, duration);
    };

    /* Slide Down */
    const slideDown = (target, time) => {
        const duration = time ? time : 500;
        target.style.removeProperty("display");
        let display = window.getComputedStyle(target).display;
        if (display === "none") display = "block";
        target.style.display = display;
        const height = target.offsetHeight;
        target.style.overflow = "hidden";
        target.style.height = 0;
        // target.offsetHeight;
        target.style.boxSizing = "border-box";
        target.style.transitionProperty = "height, margin, padding";
        target.style.transitionDuration = duration + "ms";
        target.style.height = height + "px";
        window.setTimeout(() => {
            target.style.removeProperty("height");
            target.style.removeProperty("overflow");
            target.style.removeProperty("transition-duration");
            target.style.removeProperty("transition-property");
        }, duration);
    };
    const getSiblings = function (elem) {
        const siblings = [];
        let sibling = elem.parentNode.firstChild;
        while (sibling) {
            if (sibling.nodeType === 1 && sibling !== elem) {
                siblings.push(sibling);
            }
            sibling = sibling.nextSibling;
        }
        return siblings;
    };
    const offCanvasMenu = function (selector) {
        const $offCanvasNav = document.querySelector(selector),
            $subMenu = $offCanvasNav.querySelectorAll(".sub-menu");
        $subMenu.forEach(function (subMenu) {
            const menuExpand = document.createElement("span");
            menuExpand.classList.add("menu-expand");
            // menuExpand.innerHTML = "+";
            subMenu.parentElement.insertBefore(menuExpand, subMenu);
            if (subMenu.classList.contains("mega-menu")) {
                subMenu.classList.remove("mega-menu");
                subMenu.querySelectorAll("ul").forEach(function (ul) {
                    ul.classList.add("sub-menu");
                    const menuExpand = document.createElement("span");
                    menuExpand.classList.add("menu-expand");
                    // menuExpand.innerHTML = "+";
                    ul.parentElement.insertBefore(menuExpand, ul);
                });
            }
        });

        $offCanvasNav.querySelectorAll(".menu-expand").forEach(function (item) {
            item.addEventListener("click", function (e) {
                e.preventDefault();
                const parent = this.parentElement;
                if (parent.classList.contains("active")) {
                    parent.classList.remove("active");
                    parent
                        .querySelectorAll(".sub-menu")
                        .forEach(function (subMenu) {
                            subMenu.parentElement.classList.remove("active");
                            slideUp(subMenu);
                        });
                } else {
                    parent.classList.add("active");
                    slideDown(this.nextElementSibling);
                    getSiblings(parent).forEach(function (item) {
                        item.classList.remove("active");
                        item.querySelectorAll(".sub-menu").forEach(function (
                            subMenu
                        ) {
                            subMenu.parentElement.classList.remove("active");
                            slideUp(subMenu);
                        });
                    });
                }
            });
        });
    };
    setTimeout(() => {
        offCanvasMenu(".offcanvas-menu");
    }, 5001);
    const changeLangFr = () => {
        localStorage.setItem("language", "Fr");

        history.go(0);
    };
    const changeLangEn = () => {
        localStorage.removeItem("language");
        history.go(0);
    };
    const [lang, setLang] = useState("En");
    useEffect(() => {
        if (localStorage.getItem("language") === "En") {
            setLang("En");
        } else if (localStorage.getItem("language") === "Fr") {
            setLang("Fr");
        }
    }, []);

    return (
        <>
            <header
                id="header"
                class="section header"
                style={{ height: "116px" }}
            >
                <div
                    style={{
                        background: "#c19842",
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <p
                        style={{
                            marginRight: "10px",
                            fontSize: "14px",
                            fontFamily: "Roboto, sans-serif",
                            color: "#000",
                        }}
                    >
                        Real-time Gold Price :{" "}
                        <span
                            style={{ color: "#fff" }}
                        >{`${price.price} $`}</span>
                    </p>
                    {price.chp > 0 ? (
                        <p style={{ color: "green" }}>
                            <i class="fas fa-caret-up"></i>
                            {`${price.chp}%`}
                        </p>
                    ) : (
                        <p style={{ color: "red" }}>
                            <i class="fas fa-caret-down"></i>
                            {`${price.chp}%`}
                        </p>
                    )}
                </div>
                <div class="container">
                    <div class="header-wrapper">
                        <div class="header-logo">
                            <Link to="/">
                                <img
                                    src={require("../../Assets/logo.png")}
                                    // width="150px"
                                    // style={{ transform: "scale(0.75)" }}
                                    alt=""
                                />
                            </Link>
                        </div>

                        <div class="header-middle">
                            <div class="header-menu d-none d-lg-block">
                                <ul class="main-menu">
                                    <li class="">
                                        <Link to="/">
                                            {lang === "Fr" ? `Accueil` : `Home`}
                                        </Link>
                                    </li>
                                    <li>
                                        <Link>
                                            {lang === "Fr"
                                                ? `GBI SARL`
                                                : `GBI LTD`}
                                        </Link>
                                        <ul class="sub-menu">
                                            <li>
                                                <Link to="/about-us">
                                                    {lang === "Fr"
                                                        ? `À propos de nous`
                                                        : `About Us`}
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/our-vision">
                                                    {lang === "Fr"
                                                        ? `Notre vision`
                                                        : `Our vision`}
                                                </Link>
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        <Link to="/customers">
                                            {lang === "Fr"
                                                ? `CLIENTÈLE`
                                                : `Customers`}
                                        </Link>
                                        <ul class="sub-menu">
                                            <li>
                                                <Link to="/customers">
                                                    {lang === "Fr"
                                                        ? `NOS CLIENTS`
                                                        : `Our Customers`}
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/customers">
                                                    {lang === "Fr"
                                                        ? `GOUVERNEMENTS`
                                                        : `Governments`}
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/customers">
                                                    {lang === "Fr"
                                                        ? `UTILISATEURS FINAUX C&I`
                                                        : `C&I End-Users`}
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/customers">
                                                    {lang === "Fr"
                                                        ? `GESTION DE PATRIMOINE`
                                                        : `Wealth Management`}
                                                </Link>
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        <Link to="/products-services">
                                            {lang === "Fr"
                                                ? `PRODUITS & SERVICES`
                                                : `Products & Services`}
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/procedures">
                                            {lang === "Fr"
                                                ? `PROCÉDURES`
                                                : `Procedures`}
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/global-gold">
                                            {lang === "Fr"
                                                ? `OR MONDIAL`
                                                : `Global Gold`}
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/contact-us">
                                            {lang === "Fr"
                                                ? `CONTACTEZ-NOUS`
                                                : `Contact Us`}
                                        </Link>
                                    </li>
                                </ul>
                            </div>

                            <div class="header-toggle d-lg-none">
                                <button
                                    data-bs-toggle="offcanvas"
                                    data-bs-target="#offcanvasMenu"
                                >
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </button>
                            </div>
                        </div>

                        <div class="header-meta d-none d-lg-flex align-items-center">
                            <div class="header-social">
                                <ul>
                                    <li>
                                        <a href="#">
                                            <i class="fab fa-facebook-f"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#">
                                            <i class="fab fa-twitter"></i>
                                        </a>
                                    </li>

                                    <li>
                                        <a href="#">
                                            <i class="fab fa-linkedin-in"></i>
                                        </a>
                                    </li>
                                    <li class="language">
                                        <span onClick={changeLangFr}>FR</span>|
                                        <span onClick={changeLangEn}>EN</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <div class="offcanvas offcanvas-start" id="offcanvasMenu">
                <div class="offcanvas-header">
                    <div class="offcanvas-logo">
                        <Link to="/">
                            <img
                                src={require("../../Assets/logo.png")}
                                alt="logo"
                                class="mobile-logo"
                            />
                        </Link>
                    </div>
                </div>
                <div class="offcanvas-body">
                    <div class="offcanvas-menu">
                        <ul class="main-menu">
                            <li class="active-menu">
                                <Link to="/">
                                    {lang === "Fr" ? `Accueil` : `Home`}
                                </Link>
                            </li>
                            <li>
                                <Link>
                                    {" "}
                                    {lang === "Fr" ? `GBI SARL` : `GBI LTD`}
                                </Link>
                                <ul class="sub-menu">
                                    <li>
                                        <Link to="/about-us">
                                            {lang === "Fr"
                                                ? `À propos de nous`
                                                : `About Us`}
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/our-vision">
                                            {lang === "Fr"
                                                ? `Notre vision`
                                                : `Our vision`}
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <Link to="/customers">
                                    {lang === "Fr" ? `CLIENTÈLE` : `Customers`}
                                </Link>
                                <ul class="sub-menu">
                                    <li>
                                        <Link to="/customers">
                                            {lang === "Fr"
                                                ? `NOS CLIENTS`
                                                : `Our Customers`}
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/customers">
                                            {lang === "Fr"
                                                ? `GOUVERNEMENTS`
                                                : `Governments`}
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/customers">
                                            {lang === "Fr"
                                                ? `UTILISATEURS FINAUX C&I`
                                                : `C&I End-Users`}
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/customers">
                                            {lang === "Fr"
                                                ? `GESTION DE PATRIMOINE`
                                                : `Wealth Management`}
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <Link to="/products-services">
                                    {lang === "Fr"
                                        ? `PRODUITS & SERVICES`
                                        : `Products & Services`}
                                </Link>
                            </li>
                            <li>
                                <Link to="/procedures">
                                    {lang === "Fr"
                                        ? `PROCÉDURES`
                                        : `Procedures`}
                                </Link>
                            </li>
                            <li>
                                <Link to="/global-gold">
                                    {" "}
                                    {lang === "Fr"
                                        ? `OR MONDIAL`
                                        : `Global Gold`}
                                </Link>
                            </li>
                            <li>
                                <Link to="/contact-us">
                                    {" "}
                                    {lang === "Fr"
                                        ? `CONTACTEZ-NOUS`
                                        : `Contact Us`}
                                </Link>
                            </li>
                            <li class="lang-mobile">
                                <Link>
                                    <span onClick={changeLangFr}>FR</span>|
                                    <span id="lang2" onClick={changeLangEn}>
                                        EN
                                    </span>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Navigation;
